import {GetEncodingTarget} from '@graphql/encodingTarget/query';

import EventContentTargetModel from './EventContentTargetModel';

export default function EventContentTargetEditModel() {
    let eventContentTargetModel = EventContentTargetModel();

    eventContentTargetModel.title = 'Edit Encoding Target';
    eventContentTargetModel.query.getEntity = GetEncodingTarget;

    eventContentTargetModel.fields.encoder_type.props.disabled = true;
    eventContentTargetModel.fields.distribution.props.disabled = true;
    eventContentTargetModel.fields.stream_delay_type.props.disabled = true;

    return eventContentTargetModel;
}
